module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored-81e35da77aba6be1ca7e62396b67bf39.png";